module.exports = __webpack_public_path__ + "img/Group 62@2x.78459bf6.png";